var alertToast = {
    base: {
        display: "flex",
        alignItems: "stretch",
        boxSizing: "border-box",
        font: "inherit",
        fontFamily: "body",
        borderStyle: "solid",
        borderWidth: 1,
        borderRadius: 3,
        fontSize: 3,
        color: "black.100",
        lineHeight: 4,
        width: "500px",
        "--theme-colors-shadow": "var(--theme-colors-black-shadow)",
        boxShadow: 3,
        backgroundColor: "white",
    },
    variants: {
        tone: {
            success: {
                borderColor: "success.60",
                ".icon": {
                    color: "success.60",
                },
            },
            critical: {
                borderColor: "critical.60",
                ".icon": {
                    color: "critical.60",
                },
            },
            warning: {
                borderColor: "warning.60",
                ".icon": {
                    color: "warning.60",
                },
            },
            infoPrimary: {
                borderColor: "primary.60",
                ".icon": {
                    color: "primary.70",
                },
            },
            infoSecondary: {
                borderColor: "black.60",
                ".icon": {
                    color: "black.60",
                },
            },
        },
        size: {
            lg: {
                p: 5,
            },
            md: {
                p: 5,
            },
            sm: {
                px: 4,
                py: 3,
            },
        },
    },
};
var alertCloseButton = {
    base: {
        position: "absolute",
        right: 0,
        top: 0,
        m: 1,
        color: "black.60",
        backgroundColor: "white",
        ":hover": {
            backgroundColor: "primary.10",
        },
    },
};

export { alertCloseButton, alertToast };
//# sourceMappingURL=alert.js.map
